unit uRegister;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg, WEBLib.Buttons, WEBLib.REST, WEBLib.JSON,
  uGlobal;

type
  TfrmRegister = class(TForm)
    WebImageControl1: TImageControl;
    WebPanel1: TPanel;
    lbUser: TLabel;
    lbPw: TLabel;
    edUser: TEdit;
    edPw: TEdit;
    btRegister: TButton;
    lbPwRepeat: TLabel;
    edPw2: TEdit;
    btClose: TSpeedButton;
    reqRegister: THttpRequest;
    procedure btCloseClick(Sender: TObject);
    procedure btRegisterClick(Sender: TObject);
    procedure reqRegisterRequestResponse(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; AResponse: string);
    procedure WebFormCreate(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  frmRegister: TfrmRegister;

implementation

{$R *.dfm}

procedure TfrmRegister.btCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmRegister.btRegisterClick(Sender: TObject);
var
  JSONObject: TJSONObject;
begin
  if (Trim(edUser.Text) = '') then
  begin
    ShowMessage('Gib einen Benutzernamen ein');
    exit;
  end;

  if (Trim(edPw.Text) = '') then
  begin
    ShowMessage('Gib ein Passwort ein');
    exit;
  end;

  if (edPw.Text <> edPw2.Text) then
  begin
    ShowMessage('Die Passwörter stimmen nicht überein');
    exit;
  end;

  JSONObject := TJSONObject.Create;
  JSONObject.AddPair('username', edUser.Text);
  JSONObject.AddPair('password', edPw.Text);
  reqRegister.Headers.Clear;
  reqRegister.PostData := JSONObject.ToJSON;
  reqRegister.Execute();


end;

procedure TfrmRegister.reqRegisterRequestResponse(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; AResponse: string);
var
  jo: TJSONObject;
  jv: TJSONValue;
  m: string;
begin
  try
    jo := TJSONObject.ParseJSONValue(AResponse) as TJSONObject;
    if assigned(jo) then
    begin
      m := 'no json value message';
      jv := jo.GetValue('message');
      if assigned(jv) then
      m := jv.Value;

      if (ARequest.req.Status = 201) then
      begin
        ShowMessage(m);
        edPw.Text := '';
        edPw2.Text := '';
        Close;
      end else
        ShowMessage(m);
    end;
  except
    ShowMessage('Com-Failure: ' + AResponse);

  end;



end;

procedure TfrmRegister.WebFormCreate(Sender: TObject);
begin
  reqRegister.URL := F1BET_SERVER + '/userregister/';
end;

procedure TfrmRegister.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebImageControl1 := TImageControl.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  lbUser := TLabel.Create(Self);
  lbPw := TLabel.Create(Self);
  lbPwRepeat := TLabel.Create(Self);
  edUser := TEdit.Create(Self);
  edPw := TEdit.Create(Self);
  btRegister := TButton.Create(Self);
  edPw2 := TEdit.Create(Self);
  btClose := TSpeedButton.Create(Self);
  reqRegister := THttpRequest.Create(Self);

  WebImageControl1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  lbUser.BeforeLoadDFMValues;
  lbPw.BeforeLoadDFMValues;
  lbPwRepeat.BeforeLoadDFMValues;
  edUser.BeforeLoadDFMValues;
  edPw.BeforeLoadDFMValues;
  btRegister.BeforeLoadDFMValues;
  edPw2.BeforeLoadDFMValues;
  btClose.BeforeLoadDFMValues;
  reqRegister.BeforeLoadDFMValues;
  try
    Name := 'frmRegister';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 0;
    WebImageControl1.Top := 0;
    WebImageControl1.Width := 640;
    WebImageControl1.Height := 480;
    WebImageControl1.HeightPercent := 100.000000000000000000;
    WebImageControl1.WidthPercent := 100.000000000000000000;
    WebImageControl1.Align := alClient;
    WebImageControl1.ChildOrder := 1;
    WebImageControl1.Picture.LoadFromFile('uRegister.WebImageControl1.Picture.jpg');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 201;
    WebPanel1.Top := 80;
    WebPanel1.Width := 238;
    WebPanel1.Height := 320;
    WebPanel1.Center.Horizontal := True;
    WebPanel1.Center.Vertical := True;
    WebPanel1.ElementClassName := 'loginpanel';
    WebPanel1.ChildOrder := 1;
    WebPanel1.Color := 33023;
    WebPanel1.TabOrder := 0;
    lbUser.SetParentComponent(WebPanel1);
    lbUser.Name := 'lbUser';
    lbUser.Left := 24;
    lbUser.Top := 32;
    lbUser.Width := 100;
    lbUser.Height := 18;
    lbUser.Caption := 'Benutzername';
    lbUser.Font.Charset := DEFAULT_CHARSET;
    lbUser.Font.Color := clWindowText;
    lbUser.Font.Height := -16;
    lbUser.Font.Name := 'Tahoma, Arial, sans-serif';
    lbUser.Font.Style := [];
    lbUser.HeightPercent := 100.000000000000000000;
    lbUser.ParentFont := False;
    lbUser.WidthPercent := 100.000000000000000000;
    lbPw.SetParentComponent(WebPanel1);
    lbPw.Name := 'lbPw';
    lbPw.Left := 24;
    lbPw.Top := 104;
    lbPw.Width := 65;
    lbPw.Height := 18;
    lbPw.Caption := 'Passwort';
    lbPw.Font.Charset := DEFAULT_CHARSET;
    lbPw.Font.Color := clWindowText;
    lbPw.Font.Height := -16;
    lbPw.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPw.Font.Style := [];
    lbPw.HeightPercent := 100.000000000000000000;
    lbPw.ParentFont := False;
    lbPw.WidthPercent := 100.000000000000000000;
    lbPwRepeat.SetParentComponent(WebPanel1);
    lbPwRepeat.Name := 'lbPwRepeat';
    lbPwRepeat.Left := 24;
    lbPwRepeat.Top := 176;
    lbPwRepeat.Width := 153;
    lbPwRepeat.Height := 18;
    lbPwRepeat.Caption := 'Passwort wiederholen';
    lbPwRepeat.Font.Charset := DEFAULT_CHARSET;
    lbPwRepeat.Font.Color := clWindowText;
    lbPwRepeat.Font.Height := -16;
    lbPwRepeat.Font.Name := 'Tahoma, Arial, sans-serif';
    lbPwRepeat.Font.Style := [];
    lbPwRepeat.HeightPercent := 100.000000000000000000;
    lbPwRepeat.ParentFont := False;
    lbPwRepeat.WidthPercent := 100.000000000000000000;
    edUser.SetParentComponent(WebPanel1);
    edUser.Name := 'edUser';
    edUser.Left := 24;
    edUser.Top := 64;
    edUser.Width := 193;
    edUser.Height := 28;
    edUser.ChildOrder := 1;
    edUser.Font.Charset := DEFAULT_CHARSET;
    edUser.Font.Color := clWindowText;
    edUser.Font.Height := -16;
    edUser.Font.Name := 'Tahoma, Arial, sans-serif';
    edUser.Font.Style := [];
    edUser.HeightPercent := 100.000000000000000000;
    edUser.ParentFont := False;
    edUser.WidthPercent := 100.000000000000000000;
    edPw.SetParentComponent(WebPanel1);
    edPw.Name := 'edPw';
    edPw.Left := 24;
    edPw.Top := 136;
    edPw.Width := 193;
    edPw.Height := 28;
    edPw.ChildOrder := 1;
    edPw.Font.Charset := DEFAULT_CHARSET;
    edPw.Font.Color := clWindowText;
    edPw.Font.Height := -19;
    edPw.Font.Name := 'Tahoma, Arial, sans-serif';
    edPw.Font.Style := [];
    edPw.HeightPercent := 100.000000000000000000;
    edPw.ParentFont := False;
    edPw.PasswordChar := '*';
    edPw.WidthPercent := 100.000000000000000000;
    btRegister.SetParentComponent(WebPanel1);
    btRegister.Name := 'btRegister';
    btRegister.Left := 24;
    btRegister.Top := 274;
    btRegister.Width := 193;
    btRegister.Height := 33;
    btRegister.Caption := 'Registrieren';
    btRegister.ChildOrder := 4;
    btRegister.ElementClassName := 'loginbutton';
    btRegister.Font.Charset := DEFAULT_CHARSET;
    btRegister.Font.Color := clWindowText;
    btRegister.Font.Height := -16;
    btRegister.Font.Name := 'Tahoma, Arial, sans-serif';
    btRegister.Font.Style := [];
    btRegister.HeightPercent := 100.000000000000000000;
    btRegister.ParentFont := False;
    btRegister.WidthPercent := 100.000000000000000000;
    SetEvent(btRegister, Self, 'OnClick', 'btRegisterClick');
    edPw2.SetParentComponent(WebPanel1);
    edPw2.Name := 'edPw2';
    edPw2.Left := 24;
    edPw2.Top := 208;
    edPw2.Width := 193;
    edPw2.Height := 28;
    edPw2.ChildOrder := 1;
    edPw2.Font.Charset := DEFAULT_CHARSET;
    edPw2.Font.Color := clWindowText;
    edPw2.Font.Height := -19;
    edPw2.Font.Name := 'Tahoma, Arial, sans-serif';
    edPw2.Font.Style := [];
    edPw2.HeightPercent := 100.000000000000000000;
    edPw2.ParentFont := False;
    edPw2.PasswordChar := '*';
    edPw2.WidthPercent := 100.000000000000000000;
    btClose.SetParentComponent(WebPanel1);
    btClose.Name := 'btClose';
    btClose.Left := 203;
    btClose.Top := 6;
    btClose.Width := 24;
    btClose.Height := 24;
    btClose.Color := clNone;
    btClose.ElementClassName := 'btn';
    btClose.HeightPercent := 100.000000000000000000;
    btClose.MaterialGlyph := 'close';
    btClose.TabOrder := 4;
    btClose.WidthPercent := 100.000000000000000000;
    SetEvent(btClose, Self, 'OnClick', 'btCloseClick');
    reqRegister.SetParentComponent(Self);
    reqRegister.Name := 'reqRegister';
    reqRegister.Command := httpPOST;
    reqRegister.URL := 'http://localhost:1999/userregister/';
    SetEvent(reqRegister, Self, 'OnRequestResponse', 'reqRegisterRequestResponse');
    reqRegister.Left := 496;
    reqRegister.Top := 240;
  finally
    WebImageControl1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    lbUser.AfterLoadDFMValues;
    lbPw.AfterLoadDFMValues;
    lbPwRepeat.AfterLoadDFMValues;
    edUser.AfterLoadDFMValues;
    edPw.AfterLoadDFMValues;
    btRegister.AfterLoadDFMValues;
    edPw2.AfterLoadDFMValues;
    btClose.AfterLoadDFMValues;
    reqRegister.AfterLoadDFMValues;
  end;
end;

end.